import GameConfig from "../config";
import {Vector3} from "three";

export default class CameraManager {
    static init(game){
        this.game = game;
        this.game.threeCamera.position.z = 5;
        this.game.threeCamera.position.y = 10;

        this.shakeTimer = 0;
        this.shakeIntensity = 0;
    }
    static update(target, deltaS){
        this.game.threeCamera.position.z =
            target.position.z - Math.cos(target.rotation.y) * GameConfig.CAMERA.DISTANCE.Z;

        this.game.threeCamera.position.y =
            //target.position.y +
            GameConfig.CAMERA.DISTANCE.Y;

        this.game.threeCamera.position.x = 0;

        this.game.threeCamera.lookAt(
            new Vector3(0, GameConfig.CAMERA.DISTANCE.Y- 2, target.position.z)
        );

        this.shakeTimer -= deltaS;
        if(this.shakeTimer > 0) {
            this.shake(deltaS, this.shakeIntensity);
        }
    }

    static shakeRequest(duration, intensity){
        this.shakeTimer = duration;
        this.shakeIntensity = intensity;
    }

    static shake(deltaS, intensity){
        this.game.threeCamera.position.x += (- 0.5 + Math.random()) * intensity * deltaS;
        this.game.threeCamera.position.y += (- 0.5 + Math.random()) * intensity * deltaS;
    }

}